module.exports = [["Alt-F","Format code"],["Ctrl-/ / Cmd-/","Comment/uncomment code"],["Ctrl-F / Cmd-F","Start searching"],["Ctrl-G / Cmd-G","Find next"],["Shift-Ctrl-G / Shift-Cmd-G","Find previous"],["Shift-Ctrl-R / Shift-Cmd-Option-F","Replace all"]]


//////////////////
// WEBPACK FOOTER
// ./src/utils/shortcuts.json
// module id = 369
// module chunks = 0